import React, { useRef, useEffect } from "react";
import queryString from "query-string";
import { toast } from "react-toastify";
import { useLocation, useHistory } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";

import { exchangeAmazonOAuthCode } from "../apiService/modules/amazon";
import { useRecordEvent } from "src/hooks/useRecordEvent";
import {
  completeUserSetupQuestionCardPlatform,
  doesUserHaveCardPlatform,
} from "src/apiService/modules/users";
import { dispatchIntegrationImport } from "src/store/support/actions";
import { useDispatch } from "react-redux";
import MonthYear from "src/interfaces/monthYear.interface";

export const AmazonOAuthCallbackPage = () => {
  const recordEvent = useRecordEvent();

  const location = useLocation();
  const search = location.search;
  const history = useHistory();
  const historyRef = useRef(history);
  historyRef.current = history;
  const dispatch = useDispatch();

  useEffect(() => {
    const query: {
      spapi_oauth_code?: string;
      state?: string;
      selling_partner_id?: string;
    } = queryString.parse(search);
    if (!query?.spapi_oauth_code) return;
    const code = query.spapi_oauth_code;
    const sellingPartnerId = query.selling_partner_id;

    let integrationId = undefined;
    let bankAccountId = undefined;

    let cancel = false;
    (async () => {
      let url = "/";
      try {
        if (query.state) {
          try {
            const json = JSON.parse(query.state);
            if (json.integrationId) integrationId = json.integrationId;

            if (json.back && json.back.startsWith("/")) url = json.back;
            if (json.bankAccountId) bankAccountId = json.bankAccountId;
          } catch (e) {
            console.error(e);
          }
        }
        await exchangeAmazonOAuthCode({
          integrationId,
          code,
          sellingPartnerId,
          bankAccountId,
        });
        if (cancel) return;
        toast.success("Amazon account connected!");
        if (await doesUserHaveCardPlatform("Amazon")) {
          await completeUserSetupQuestionCardPlatform("Amazon");
          if (integrationId) {
            const currentDate = new Date();
            await dispatch(
              dispatchIntegrationImport(integrationId, "direct-import-sales", {
                start: { month: 1, year: currentDate.getFullYear() - 1 },
                end: {
                  month: currentDate.getMonth() + 1,
                  year: currentDate.getFullYear(),
                } as MonthYear,
              })
            );
          }
        }
        recordEvent({
          type: "feature-adoption",
          feature: "integration-added",
          element: "sale-platform-amazon",
        });
      } catch (e) {
        console.error(e);
        if (cancel) return;
        toast.error((e as Error).toString());
      }
      historyRef.current.push(url);
    })();

    return () => {
      cancel = true;
    };
  }, [search]);

  return (
    <Container component="main" maxWidth="xs">
      <Box className="flex justify-center items-center h-screen">
        <CircularProgress size={50} />
      </Box>
    </Container>
  );
};

export default AmazonOAuthCallbackPage;
